import { Component, OnInit } from '@angular/core';

import { NgClass, NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { VexDateFormatRelativePipe } from '@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';

import { AuthService } from 'src/app/core/auth/auth.service';
import { UserAuthData } from 'src/app/core/auth/authData.model';
import { FechaEspanolPipe } from 'src/app/pipes/fecha-espanol.pipe';
import { Notifications } from '../interfaces/notification.interface';
import { NotificationsService } from '../services/notifications.service';


@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    VexDateFormatRelativePipe,
    FechaEspanolPipe
  ]
})
export class ToolbarNotificationsDropdownComponent implements OnInit {
  notifications: Notifications[] = []


  currentUser: UserAuthData | null = null;

  constructor(
    private notificationsService: NotificationsService,
    private authService: AuthService
    ) {}

    ngOnInit(): void {
      this.notificationsService.notifications$.subscribe((notifications) => {
        if (Array.isArray(notifications)) {
          this.notifications = notifications.map((log: any) => new Notifications(log));

          // Check if there are unread notifications
          const hasUnread = this.notifications.some(notification => !notification.leida);
          this.notificationsService.setNewNotification(hasUnread);
        } else {
          console.error("Las notificaciones no tienen el formato esperado:", notifications);
        }
      });
    }



    trackById(index: number, item: Notifications): number | undefined {
      return item.id;
    }

    markAsRead(notificationId: number | undefined): void {
      if (notificationId === undefined) {
        console.error('Intento de marcar como leída una notificación sin ID');
        return;
      }
      this.currentUser = this.authService.getCurrentUser();
      const notification = this.notifications.find(n => n.id === notificationId);
      if (notification) {
        notification.leida = true;
        const id_usuario = this.currentUser?.idEmp ?? 0;
        this.notificationsService.updateNotificationReadState(notificationId, id_usuario).subscribe({
          error: (err) => console.error('Error al marcar la notificación:', err)
        });
      }
    }

    markAllAsRead(): void {
      this.notifications.forEach(n => n.leida = true);  // Cambia el estado de todas las notificaciones a leídas
      this.currentUser = this.authService.getCurrentUser();
      const id_usuario = this.currentUser?.idEmp ?? 0;

      // Realiza la solicitud para marcar todas las notificaciones como leídas
      this.notificationsService.updateAllNotificationsReadState(id_usuario).subscribe({
        next: () => {
          // Aquí actualizas las notificaciones en el componente sin tener que recargar la página
          this.notifications.forEach(n => n.leida = true);  // Actualiza localmente
        },
        error: (err) => {
          console.error('Error al marcar todas las notificaciones:', err);
        }
      });
    }

}
